import { cr } from "fire-wind-water";
import Api from "../service/api";
import WX from "../utils/wx";
import Utils from "../utils/index";
import { interact, URLS } from "fire-wind-water";
import { forkJoin } from "rxjs";
import WeChat from "@/components/WeChat";
import FormStatus from "@/components/FormStatus.vue";
import Header from "@/components/Header.vue";
import CountDown from "@/components/CountDown.vue";
import { questionartData } from "@/service/mock";

const questionaryMixin = {
  data() {
    return {
      questionnaireList: [],
      questionItem: [],
      isPreview: Number(URLS.getURL("preview") || URLS.getHash("preview")),
      hasJoin: 0,
      schemaId: 0,
      instanceId: 0,
      tenantId: 0,
      isSubmitting: false,
      showInWechat: false,
      isShowBtn: false,
      qrcodeUrl: "",
      contactInfo: null,
      questionnaireInfo: {},
      questionRulesInfo: [],
      lookUpInfo: [],
      questionnaireId:
        URLS.getURL("questionaryId") || URLS.getHash("questionaryId"),
      sess: "",
      identity: null,
      questionaryStatus: 0,
      errorMessage: "",
      title: "",
      rulesJump: 0,
      isSetting: Number(URLS.getURL("isSetting") || URLS.getHash("isSetting")),
      limitTimeToken: Utils.limitTimeToken(), //生成需要计时时随机串
      costTime: 0, //问卷校准偏移量，单位s
    };
  },
  created() {
    if (this.isSetting) {
      this.initMockQuestionary();
      const id = URLS.getURL("configId") || URLS.getHash("configId");
      this.initConfig(id, this.tenantId);
      return;
    }
    window.$sk.loading.show();
    this.module = window.$sk.template.module(this);
  },
  computed: {
    pageFontClass() {
      let fontClassArray = {
        NotoSeriSCLight: "page-font-1",
        NotoSeriSCRegular: "page-font-2",
        NotoSansSCLight: "page-font-3",
        SourceHanSansLight: "page-font-4",
        InterLight: "page-font-1",
        InterRegular: "page-font-2",
        IBMPlexMonoMedium: "page-font-3",
        IBMPlexMonoRegular: "page-font-4",
      };
      return (
        fontClassArray[this.extraItem.extras("formFontFamily.pageFont")] ||
        "default"
      );
    },
  },
  watch: {
    pageFontClass() {
      document.body.className = this.pageFontClass;
    },
  },
  components: {
    WeChat,
    FormStatus,
    Header,
    CountDown,
  },
  beforeDestroy() {
    this.module.unsubscribe();
  },
  methods: {
    skUserInit() {
      console.log("获取用户本地信息");
    },
    skUserEnd() {
      console.log("获取用户信息结束");
      const info = window.$sk.template.get();
      this.schemaId = info.common.schemaId;
      this.moduleId = info.common.moduleId;
      this.instanceId = info.common.instanceId;
      this.tenantId = info.common.tenantId;
      this.sess = info.user.session;
      this.globalUserId = info.user.globalUserId;
      this.contactInfo = info.user;
      this.enteredId =
        this.contactInfo.status && this.contactInfo.status.enteredId
          ? this.contactInfo.status.enteredId
          : "";
      this.getQuestionnaire();
      const id = URLS.getURL("configId") || URLS.getHash("configId");
      this.initConfig(id, this.tenantId);
    },
    skUserChange(data) {
      console.log("用户信息发生改变");
      if (data) {
        this.contactInfo.status = data.status;
        if (
          this.questionnaireInfo.attendWay == 4 &&
          this.contactInfo.status &&
          this.contactInfo.status.signupStatus &&
          (this.contactInfo.status?.signupStatus?.toLowerCase() ===
            "notallow" ||
            this.contactInfo.status?.instanceDesc?.toLowerCase() ===
              "completed")
        ) {
          //signupDesc
          this.errorMessage = "抱歉，主办方要求报名用户方可参与！";
        } else if (
          this.contactInfo.status &&
          this.contactInfo.status.signupState &&
          this.contactInfo.status.signupStatus &&
          this.contactInfo.status.signupState == "successfully" &&
          this.contactInfo.status.signupStatus == "pending"
        ) {
          //报名审核中
          this.errorMessage = "您的报名资料正在审核中";
        }
        this.enteredId =
          this.contactInfo.status && this.contactInfo.status.enteredId
            ? this.contactInfo.status.enteredId
            : "";
      }
    },
    skLinkEnd(o) {
      if (!o.isJump || this.isPreview) {
        this.getSuccess(this.questionnaireInfo);
        if (!this.isPreview) {
          this.browse();
        }
      }
      console.log("跳转逻辑判断完毕");
    },
    getQuestionnaire() {
      forkJoin(
        this.handleBindData(),
        this.questionnaireGet(),
        this.questionRulesGet()
      ).subscribe((res) => {
        const data = res[1];
        this.questionnaireInfo = data.content;
        this.questionItem = data.content.items;
        // this.questionnaireInfo.limitTime = 0.1;//pegmca
        this.lookUpInfo =
          res[0] && this.questionnaireInfo.attendWay != 1 ? res[0].content : [];
        const platform = interact.isMobile == 1 ? "wap" : "pc";
        const anotherPlatform = interact.isMobile == 1 ? "pc" : "wap";
        if (location.hash.indexOf("/" + platform + "/") == -1) {
          if (this.isPreview) {
            window.location.href = window.location.href
              .replace("/" + anotherPlatform + "/", "/" + platform + "/")
              .replace(
                this.questionnaireInfo.template[anotherPlatform]["configId"],
                this.questionnaireInfo.template[platform]["configId"]
              );
          } else {
            let url = this.questionnaireInfo.shortUrl[platform].longUrl;
            if (url.indexOf("puzzleFlag") > -1) {
              url = URLS.updateSearchParam(
                "return_url",
                encodeURIComponent(
                  URLS.updateSearchParam(
                    "linkId",
                    URLS.getURL("linkId"),
                    decodeURIComponent(URLS.getURL("return_url", url))
                  )
                ),
                url
              );
            } else {
              url = URLS.updateSearchParam(
                "linkId",
                URLS.getURL("linkId"),
                url
              );
            }
            window.location.href = url;
          }
          return;
        }
        Utils.changeHash(this.questionnaireInfo); //判断问卷类型跳转对应路由
        if (interact.isWeChat) {
          WX.initWeChatShare(this.questionnaireInfo);
        }
        this.title = this.questionnaireInfo.title;
        this.identity = this.questionnaireInfo.attendWay;
        this.questionRulesInfo = res[2].content.items;
        window.$sk.template.update({
          type: "link",
          data: {
            identity: this.questionnaireInfo.attendWay,
            weChatId: this.questionnaireInfo.attachWXAccount,
            skObjectType: "questionary",
            skObjectId: this.questionnaireId,
            meetingInstanceId:
              this.questionnaireInfo.attendWay == 4
                ? this.questionnaireInfo.meetingInstanceId
                : this.instanceId,
            meetingType: this.questionnaireInfo.meetingType,
            skIsNotLink: this.isPreview ? 1 : 0,
            memberFormId: this.questionnaireInfo.regFormId,
          },
        });
      });
    },
    submit(isAutoAction = 0) {
      if (this.isSetting) {
        window.$sk.alert("当前页面不支持提交");
        return;
      }
      if (this.hasJoin) {
        return;
      }
      if (this.isPreview && this.questionnaireInfo.type == 3) {
        //试卷类型预览不提交
        return;
      }
      if (this.identity == null || this.contactInfo == null) {
        window.$sk.alert("请登录");
        return false;
      }
      if (this.questionnaireInfo.attentionWeChat == "1") {
        window.$sk.alert("请在微信中参与");
        return false;
      }

      console.log("userINfo--", this.contactInfo);
      this.questionnaireList = this.questionnaireList.filter((m) => {
        m.checkFlag = !m.checkFlag; //触发校验
        return true;
      });
      // cr.each(this.questionnaireList, (m) => {
      //   m.checkFlag = !m.checkFlag; //触发校验
      // });
      this.$nextTick(() => {
        console.log("res--questionnaireList--", this.questionnaireList);
        let isValid = true; //校验结果
        let hasAnswers = 0;
        cr.each(this.questionnaireList, (m) => {
          if (m.value) {
            if (m.value.value && m.value.value.length) {
              hasAnswers++;
            }
            if (m.value.VerifyFail && m.isShow) {
              isValid = false;
            }
            /*          //3自定义单行文本 4 自定义多行文本 1全局单行 2 全局多行
            if((m.type==3||m.type==4 ||m.displayType==1||m.displayType==2)&&!m.isShow&&m.value.VerifyFail){
              m.value.value="";
            }*/
          }
        });
        if (isValid || isAutoAction) {
          //通过校验
          if (hasAnswers === 0 && !isAutoAction) {
            window.$sk.alert("请至少填写一个字段信息");
            return false;
          }
          if (this.isSubmitting) {
            return;
          }
          this.isSubmitting = true;
          let submitFields = [];
          cr.each(this.questionnaireList, (m) => {
            if (m.isShow) {
              if (m.fieldLevel == 4) {
                if (
                  m.displayType == 3 ||
                  m.displayType == 4 ||
                  m.displayType == 5 ||
                  m.displayType == 6 ||
                  m.type == 9 ||
                  m.type == 10
                ) {
                  //下拉/单选/多选
                  let options = [];
                  if (m.result && Array.isArray(m.result.model)) {
                    //多选
                    cr.each(m.result.model, (u) => {
                      if (u.otherisFillIn == 1) {
                        options.push({
                          isFill: u.otherisFillIn,
                          isother: u.otherisFillIn,
                          optionId: u.optionId,
                          text: u.otherValue,
                        });
                      } else {
                        options.push({
                          optionId: u.optionId,
                        });
                      }
                    });
                    submitFields.push({
                      itemId: m.itemId,
                      options: options,
                      value: m.value.value,
                    });
                  } else {
                    //单选
                    const model = m.result.model;
                    if (model.otherisFillIn == 1) {
                      options = [
                        {
                          isFill: model.otherisFillIn,
                          isother: model.otherisFillIn,
                          optionId: model.optionId,
                          text: model.otherValue,
                        },
                      ];
                    } else {
                      options = [{ optionId: model.optionId }];
                    }
                    submitFields.push({
                      itemId: m.itemId,
                      options: options,
                    });
                  }
                } else if (m.displayType == 7 || m.displayType == 8) {
                  //图片/文件
                  submitFields.push({
                    itemId: m.itemId,
                    fileName: m.value.value ? m.value.value.fileName : "",
                    mapId: m.value.value ? m.value.value.mapId : "",
                    newPath: m.value.value ? m.value.value.newPath : "",
                  });
                } else if (m.fieldType == "DESC" || m.fieldType == "LINE") {
                  //描述/分割线
                  submitFields.push({
                    fieldName: m.fieldName,
                    value: "",
                  });
                } else {
                  submitFields.push({
                    itemId: m.itemId,
                    answer: m.value.value,
                  });
                }
              } else {
                if (m.fieldType != "POLICY") {
                  if (
                    m.fieldName === "mobile" &&
                    m.value.checkCode &&
                    m.isShow
                  ) {
                    submitFields.push({
                      fieldName: m.value.fieldName,
                      value: m.value.value,
                      checkCode: m.value.checkCode,
                    });
                  } else {
                    submitFields.push({
                      fieldName: m.value.fieldName,
                      value: m.value.value,
                    });
                  }
                } else {
                  submitFields.push({
                    fieldName: m.value.fieldName,
                    value: m.value.value,
                  });
                }
              }
            }
          });
          console.log("submitFields", submitFields);
          this.actionFun(submitFields, isAutoAction);
        } else {
          this.validationErrorHandler();
        }
      });
    },
    actionFun(answers, isAutoAction = 0) {
      let params = {
        questionaryId: this.questionnaireId,
        globalUserId: this.globalUserId,
        referenceUrl: document.referrer,
        options: answers,
        url: window.location.href,
        preview: this.isPreview ? 1 : 0,
        sess: this.sess,
        session: this.sess,
        memberId: null,
        linkId: URLS.getURL("linkId") || URLS.getHash("linkId"),
        unique: this.contactInfo.unique ? this.contactInfo.unique : "",
        enteredId: this.enteredId,
        instanceId: this.instanceId || 0,
        type: this.questionnaireInfo.type,
        _withAsync: this.questionnaireInfo.type == 3 ? 0 : 1,
        isAutoAction: isAutoAction,
        token: this.limitTimeToken,
        costTime: this.$refs["count-down"].costTimeFront,
      };
      if (this.rulesJump == 2) {
        params = { rulesJump: this.rulesJump, ...params };
      }
      if (interact.isMobile) {
        let weixinId =
          this.questionnaireInfo.attachWXAccount &&
          this.questionnaireInfo.attachWXAccount != 0
            ? this.questionnaireInfo.attachWXAccount
            : URLS.getHash("weChatId") || URLS.getHash("weChatId");
        Object.assign(params, {
          openId: this.contactInfo.openId,
          weChatId: weixinId,
        });
      }
      this.contactInfo.token = this.limitTimeToken; //this.contactInfo存在token字段
      Object.assign(params, this.contactInfo);
      Api.questionaryAction(params).subscribe((data) => {
        this.isSubmitting = false;
        let _this = this;
        if (data.result == 0) {
          if (data.content.repeatAction == 1) {
            window.$sk.confirm("您已提交过，是否直接进入下一步？", {
              okValue: "下一步",
              ok: function () {
                _this.judgeCompleteActionType(
                  _this.questionnaireInfo.completeActionType,
                  _this.questionnaireInfo.completeAction,
                  data.content
                ); // 判断问卷结束后行为
              },
            });
          } else {
            _this.judgeCompleteActionType(
              _this.questionnaireInfo.completeActionType,
              _this.questionnaireInfo.completeAction,
              data.content
            ); // 判断问卷结束后行为
          }
        } else if (data.result == "100040") {
          window.$sk.confirm(data.desc, {
            okValue: "下一步",
            ok: function () {
              _this.judgeCompleteActionType(
                _this.questionnaireInfo.completeActionType,
                _this.questionnaireInfo.completeAction,
                data.content
              ); // 判断问卷结束后行为
            },
          });
        } else {
          window.$sk.alert(data.desc);
        }
      });
    },
    getSuccess(info) {
      console.log(Utils.inIframe());

      // 如果表单中有分割线和描述则读取itemsAll
      // info.items = info.itemsAll && info.itemsAll.constructor === Array  ? info.itemsAll : info.items;

      if (info.attentionWeChat == "1" && !interact.inWeChat) {
        window.$sk.loading.hide();
        this.showInWechat = true;
        this.qrcodeUrl = info.shortUrl.wap.normal;

        return;
      }

      if (!this.isPreview) {
        //获取服务器时间
        Api.getServerTime({}).subscribe((data) => {
          if (data.result == 0) {
            let currentTime = Number(data.content);
            this.questionaryStatus = info.status;
            if (
              (info.manualStartTime === 0 ||
                (info.manualStartTime && currentTime < info.manualStartTime)) &&
              info.startTime &&
              currentTime < info.startTime
            ) {
              this.questionaryStatus = 0;
            } else if (
              (info.manualEndTime && currentTime > info.manualEndTime) ||
              (info.endTime && currentTime > info.endTime)
            ) {
              this.questionaryStatus = 2;
            } else {
              this.questionaryStatus = 1;
            }
          } else {
            this.questionaryStatus = info.status;
          }
          this.renderByStatus();
        });
      } else {
        this.questionnaireList = this.handleList(info);
        this.handleRules();
        window.$sk.loading.hide();
        this.isShowBtn = true;
      }
    },
    validationErrorHandler() {
      // 定位到错误位置
      for (let elem of this.$el.getElementsByClassName("err")) {
        if (elem) {
          if (
            elem.style.display != "none" &&
            elem.parentNode.style.display != "none"
          ) {
            document.documentElement.scrollTop = elem.offsetTop - 20;
            document.body.scrollTop = elem.offsetTop - 20;
            break;
          }
        }
      }
    },
    renderByStatus() {
      if (this.questionaryStatus == 0 || this.questionaryStatus == 2) {
        window.$sk.loading.hide();
        this.errorMessage =
          this.questionaryStatus == 0 ? "活动未开始！" : "活动已结束！";
      } else {
        this.getHasJoin();
      }
    },
    getHasJoin() {
      const params = {
        questionaryId: this.questionnaireId,
        instanceId: this.instanceId || 0,
        openId: this.contactInfo.openId,
        globalUserId: this.globalUserId,
        linkId: URLS.getURL("linkId") || URLS.getHash("linkId"),
        sess: this.sess,
        url: window.location.href,
        referenceUrl: document.referrer,
      };
      Api.getHasJoin(params).subscribe((data) => {
        if (data.result == "0") {
          this.hasJoin = Number(data.content.hasJoin);
          this.questionnaireList = this.handleList(this.questionnaireInfo);
          this.handleRules();
          this.isShowBtn = true;
          if (this.hasJoin) {
            this.judgeCompleteActionType(
              this.questionnaireInfo.completeActionType,
              this.questionnaireInfo.completeAction,
              data.content
            );
            window.$sk.loading.hide();
          } else {
            //可以参与问卷
            window.$sk.loading.hide();
            this.questionTimeLimit();
          }
        } else {
          window.$sk.loading.hide();
          this.errorMessage = data.desc;
        }
      });
    },
    handleRules() {
      if (this.$refs.questionChild) {
        this.$refs.questionChild.initData();
      }
    },
    dicValueConvert(m) {
      //字典中文转换为dicId;
      let value = "";
      let child = [];
      if (m.listOptionType == "DICT") {
        this.questionItem.forEach((a) => {
          if (a.fieldName == m.fieldName) {
            a.dictInfo.forEach((d) => {
              if (d.name == m.value[0]) {
                if (m.value.length == 1) {
                  value = d.paramId;
                } else {
                  for (let key in d.child) {
                    child = d.child[key];
                  }
                  let maxLength = m.value.length;
                  let i = 1;
                  while (i < maxLength) {
                    for (let obj of child) {
                      if (obj.name == m.value[i]) {
                        if (i != maxLength - 1) {
                          for (let key in obj.child) {
                            child = obj.child[key];
                          }
                        } else {
                          value = obj.paramId;
                        }
                        break;
                      }
                    }
                    i++;
                  }
                }
              }
            });
          }
        });
      } else if (m.listOptionType == "CUSTOM") {
        value = m.value.toString();
      }
      return value;
    },
    handleList(info) {
      let res = info ? info.items : [];
      let needHideQuestion = [];
      let ruleModel = {};
      let hideData = {};
      if (this.questionRulesInfo.length > 0) {
        this.questionRulesInfo.forEach((r) => {
          r.rules.forEach((item) => {
            if (item.rulesJump == 3) {
              needHideQuestion.push(item.rulesGoto);
            }
          });
        });
      }
      cr.each(res, (m, index) => {
        if (m.fieldLevel == 4) {
          cr.each(m.options, (u) => {
            u.optionValue = u.title;
            u.otherisFillIn = u.isFillIn;
            u.otherIsRequire = u.isFillInRequire;
          });
          m.listOptions = m.options;
          m.required = m.necessary;
          m.displayName = m.question;
          m.displayType = Utils.changeType(m.type);
          if (m.displayType == 3 || m.displayType == 4) {
            m.displayName = m.displayName.replace(
              /^(\d+\. )?(.*)$/,
              "$1[单选]$2"
            );
          }
          if (m.displayType == 5 || m.displayType == 6) {
            m.displayName = m.displayName.replace(
              /^(\d+\. )?(.*)$/,
              "$1[多选]$2"
            );
          }
        }

        this.lookUpInfo.forEach((n) => {
          if (n.key == m.fieldName) {
            m.value = n.value;
            m.ruleValue = n.value;
          }
        });
        m.required = Number(m.required);
        //问卷规则 随机问卷没有规则
        if (this.questionRulesInfo.length > 0) {
          ruleModel = this.questionRulesInfo.find((r) => {
            return r.rulesCode == m.fieldName;
          });
          hideData = needHideQuestion.filter((r) => {
            return m.fieldName == r;
          });
          m.sortBy = index; //用于跳题隐藏
          if (
            ruleModel &&
            (m.fieldLevel == 1 || m.fieldLevel == 2 || m.fieldLevel == 3) &&
            Array.isArray(m.value) &&
            m.value.length > 0
          ) {
            m.ruleValue = this.dicValueConvert(m);
          }
          if (ruleModel) {
            m.rulesInfo = {
              rulesType: ruleModel.rulesType,
              rules: ruleModel.rules,
            };
          }
          m.isShow = hideData.length > 0 ? false : true;
          m.isOldShow = m.isShow; //后面切换题目 还原数据需要
        } else {
          m.isShow = true;
        }
      });
      console.log(res);
      return res;
    },
    judgeCompleteActionType(completeActionType, completeAction, data) {
      this.$refs["count-down"].clearMyInterval(); //关闭计时器
      this.$refs["count-down"].onbeforeunloader(1); //注销监听页面刷新
      let returnUrl = URLS.getHash("returnUrl");
      switch (
        completeActionType //新接口后端做了类型修改
      ) {
        case 0:
          this.errorMessage = completeAction;
          break;
        case 1: // 跳转到抽奖
          this.redirectToLuckyDraw(completeAction);
          break;
        case 2: // 跳转链接
          if (data && data.scoreJump == "1") {
            if (!data.jumpUrl) {
              let query = {};
              if (this.questionnaireInfo.type == 3 && data) {
                query = {
                  ...query,
                  ...{ score: data.score, answerId: data.answerId },
                };
              }
              this.$router.push({ path: "success", query: query });
            } else {
              window.location.href = data.jumpUrl;
            }
          } else {
            window.location.href = completeAction;
          }
          break;
        case -1: // 跳转到结果页
          //后加逻辑
          if (returnUrl) {
            window.$sk.goto(returnUrl);
          } else {
            let query = {};
            if (this.questionnaireInfo.type == 3 && data) {
              query = {
                ...query,
                ...{ score: data.score, answerId: data.answerId },
              };
            }
            this.$router.push({ path: "success", query: query });
          }
          break;
      }
    },
    redirectToLuckyDraw(luckyDrawId) {
      Api.getLuckyDraw({
        luckyDrawId: luckyDrawId,
      }).subscribe((data) => {
        let mobileObj = data["content"]["template"]["mobile"];

        window.$sk.goto(
          mobileObj["formalUrl"] +
            "?luckyDrawId=" +
            luckyDrawId +
            "&configId=" +
            mobileObj["configId"]
        );
      });
    },
    handleBindData() {
      //获取回填的用户信息
      return Api.memberLookUp({
        instanceId: this.moduleId == 2 ? 0 : this.instanceId || 0, //线上会传0
        openId: this.contactInfo.openId,
        tenantId: this.tenantId,
        questionnaireId: this.questionnaireId,
        globalUserId: this.globalUserId,
        sess: this.sess,
        session: this.sess,
      });
    },
    questionnaireGet() {
      return Api.getQuestionnaire({
        tenantId: this.tenantId,
        questionnaireId: this.questionnaireId,
      });
    },
    questionRulesGet() {
      return Api.getQuestionnaireRules({
        tenantId: this.tenantId,
        questionnaireId: this.questionnaireId,
      });
    },
    browse() {
      Api.browse({
        openId: this.contactInfo.openId,
        sess: this.sess,
        globalUserId: this.globalUserId,
        tenantId: this.tenantId,
        questionnaireId: this.questionnaireId,
      });
    },
    initMockQuestionary() {
      this.title = questionartData.title;
      this.questionnaireList = this.handleList(questionartData);
      this.handleRules();
      this.isShowBtn = true;
    },
    //问卷限时设置功能，并弹窗
    questionTimeLimit() {
      //设置答题时限
      if (
        this.questionnaireInfo.isTimeLimit == "2" &&
        this.questionnaireInfo.limitTime > 0
      ) {
        window.$sk.alert(
          "<div style='font-weight: bold;margin-bottom: 10px'>限时答题提醒</div><div>答题超过" +
            this.questionnaireInfo.limitTime +
            "分钟后会自动提交</div>",
          {
            okValue: "开始答题",
            ok: () => {
              this.questionnaireTimeStart();
              this.$refs["count-down"].onbeforeunloader(); //监听页面刷新
            },
          }
        );
      } else {
        this.questionnaireTimeStart();
      }
    },
    //开始答题
    questionnaireTimeStart() {
      let params = {
        questionIds: this.questionnaireId,
        openId: this.contactInfo.openId,
        globalUserId: this.globalUserId,
        sess: this.sess,
        token: this.limitTimeToken,
      };
      Api.questionnaireTimeStart(params).subscribe((data) => {
        if (data.result == "0") {
          this.$refs["count-down"].init();
          this.$refs["count-down"].blurOrfocus(); //监听获取焦点时，校准时间
          // if(this.questionnaireInfo.isTimeLimit == '2' && this.questionnaireInfo.limitTime > 0){
          //   this.$refs['count-down'].blurOrfocus();//监听获取焦点时，校准时间
          // }
        }
      });
    },
    //答题时间校准
    questionnaireTimeGet() {
      let params = {
        questionIds: this.questionnaireId,
        openId: this.contactInfo.openId,
        globalUserId: this.globalUserId,
        sess: this.sess,
        token: this.limitTimeToken,
      };
      Api.questionnaireTimeGet(params).subscribe((data) => {
        if (data.result == "0") {
          if (data.content?.costTime) {
            //有返回值时，重置计时
            this.costTime = data.content?.costTime;
            this.$nextTick(() => {
              this.$refs["count-down"].init(); //重置计时
            });
          }
        }
      });
    },
  },
};
export default questionaryMixin;
